import { APP_ROUTES } from "../constants";

export const getTagsetDetailPageUrl = (id: number | string): string =>
  `${APP_ROUTES.private_routes.tagsets}/${id}`;
